import React from 'react';
import styled from 'styled-components';
import { Flex } from 'src/packages/core';

export const FooterContainer = styled.footer`
  grid-area: footer;
  background-color: ${({ theme }) => theme.colors.palette.black};
  padding: 60px 112px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: ${(props) => (props.theme.rtl ? 'flex-end' : 'flex-start')};

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 30px 0 78px 0;
  }
`;

export const IconsWrapper = styled((props) => <Flex {...props} />)`
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 16px;

  > span {
    cursor: pointer;
    height: 30px;

    * {
      cursor: pointer !important;
    }

    > svg {
      &:hover {
        path[stroke] {
          stroke: ${(props) => props.theme.colors.palette.primary};
        }

        path[fill] {
          fill: ${(props) => props.theme.colors.palette.primary};
        }
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.md} {
    width: 100%;
  }
`;
